<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Tax Investment {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto" *ngIf="this.Filter.IsDraft">
                <span class="badge view">Draft</span>
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'pendingwithsenior'}">{{DetailData.Table[0].ApprovalStatus}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Table[0].Photo != null && DetailData.Table[0].Photo != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(DetailData.Table[0].Photo)" />
                                        <div *ngIf="DetailData.Table[0].Photo == null || DetailData.Table[0].Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.Table[0].EmpName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.Table[0].EmpName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.Table[0].EmpCode}}</label><br />
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-5">
                                    <label for="FromDate" class="text-label-light">Financial Year Start</label> <br />
                                    <label name="FromDate"
                                        class="text-label-dark">{{DetailData.Table[0].FinancialYearStart}}</label>
                                </div>
                                <div class="col-md-5">
                                    <label for="ToDate" class="text-label-light">Financial Year End</label> <br />
                                    <label name="ToDate" class="text-label-dark">{{DetailData.Table[0].FinancialYearEnd
                                        | date :'dd MMM yyyy'}}</label>
                                </div>
                                <div class="col-md-2">
                                    <label for="NoOfDays" class="text-label-light">Regime</label> <br />
                                    <label name="NoOfDays"
                                        class="text-label-dark">{{DetailData.Table[0].IsNewRegime?'New':'Old'}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-briefcase px-2"></i>Previous Employment Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardPreviousEmployment?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardPreviousEmployment" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardPreviousEmployment')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardPreviousEmployment">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <!-- <th class="sticky-col">Month</th>
                                                    <th class="sticky-col">Year</th> -->
                                                    <th>Remark</th>
                                                    <th>Basic</th>
                                                    <th class="text-end">DA</th>
                                                    <th class="text-end">HRA</th>
                                                    <th class="text-end">Allowance</th>
                                                    <th class="text-end">Gross</th>
                                                    <th class="text-end">PT</th>
                                                    <th class="text-end">PF</th>
                                                    <th class="text-end">TDS</th>
                                                    <th class="text-end">Deduction</th>
                                                    <th class="text-end">Net</th>
                                                    <th class="sticky-col">Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of DetailData.ESS_TaxPreviousEmploymentDetails; let i = index">
                                                    <!-- <td class="sticky-col">
                                                        {{element.Monthname}}
                                                    </td>
                                                    <td class="sticky-col align-center">
                                                        {{element.Yearname}}
                                                    </td> -->
                                                    <td>
                                                        {{element.Remarks}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.Basic}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.DA}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.HRA}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.OtherAllowance}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.GrossAmount}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PT}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PF}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.TDS}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.OtherDeduction}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.NetAmount}}
                                                    </td>
                                                    <td class="sticky-col"
                                                        style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length?attachmentPopup(i,1):null">
                                                            <span
                                                                *ngIf="element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0"
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-card-checklist px-2"></i>Chapter VI A Details
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>Section Code</th>
                                                        <th>Section</th>
                                                        <th>IncomeHead</th>
                                                        <th>Sub Section</th>
                                                        <th>Limit Applicable</th>
                                                        <th>Max Limit</th>
                                                        <th class="text-end">Proof Submission Amount</th>
                                                        <th class="text-end">Approved Amount</th>
                                                        <th class="sticky-col">Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let element of DetailData.ESS_EmpTaxInvestmentDetails; let i = index">
                                                        <td>{{element.SectionCode}}</td>
                                                        <td>{{element.SectionName}}</td>
                                                        <td>{{element.IncomeHead}}</td>
                                                        <td>{{element.SubSectionName}}</td>
                                                        <td>{{DetailData.Table[0].IsNewRegime?element.IsNewMaxlimitapplicable:element.IsOldMaxlimitapplicable}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{DetailData.Table[0].IsNewRegime?element.NewRegimeMaxAmount:element.OldRegimeMaxAmount}}
                                                        </td>
                                                        <td class="text-end">{{element.ProofSubmissionAmount}}</td>
                                                        <td class="text-end">{{element.ApprovedAmount}}</td>
                                                        <td class="sticky-col"
                                                            style="align-content: center;text-align: -webkit-center;">
                                                            <i type="button"
                                                                class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                                (click)="element.ESS_EmpTaxInvestmentDetails_Attachment.length?attachmentPopup(i,2):null">
                                                                <span
                                                                    *ngIf="element.ESS_EmpTaxInvestmentDetails_Attachment.length > 0"
                                                                    class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                    style="font-size: 10px;">
                                                                    {{element.ESS_EmpTaxInvestmentDetails_Attachment.length}}
                                                                </span>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!isLoad">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <span class="custome-header">
                                    <i class="bi bi-house px-2"></i>Are you staying in a rented house?
                                </span>
                            </div>
                            <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                                <span class="px-1"
                                    style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_HRA?'Yes':'No'}}</span>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        [checked]="OpenCard.CardEmpTaxDeclarationDetails_HRA"
                                        id="flexSwitchCheckChecked"
                                        (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_HRA')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_HRA">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>FromDate</th>
                                                        <th>ToDate</th>
                                                        <th class="text-end">Monthly Rent</th>
                                                        <th>Name Of Landloard</th>
                                                        <th>Land LordPanNo</th>
                                                        <th>Address</th>
                                                        <th>IsMetroCity</th>
                                                        <th class="text-end">Submission Amount</th>
                                                        <th class="text-end">Approved Amount</th>
                                                        <th>Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let element of DetailData.ESS_EmpTaxDeclarationDetails_HRA; let i = index">
                                                        <td>
                                                            {{element.FromDate}}
                                                        </td>
                                                        <td>
                                                            {{element.ToDate}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{element.ApprovedAmount}}
                                                        </td>
                                                        <td>
                                                            {{element.NameOfLandlord}}
                                                        </td>
                                                        <td>
                                                            {{element.LandLordPanNo}}
                                                        </td>
                                                        <td>
                                                            {{element.Address}}
                                                        </td>
                                                        <td style="align-content: center;text-align: -webkit-center;">
                                                            {{element.IsMetroCity?'Yes':'No'}}
                                                        </td>
                                                        <td class="text-end">{{element.ProofSubmissionAmount}}</td>
                                                        <td class="text-end">{{element.ApprovedAmount}}</td>
                                                        <td style="align-content: center;text-align: -webkit-center;">
                                                            <i type="button"
                                                                class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                                (click)="element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length>0?attachmentPopup(i,3):null">
                                                                <span
                                                                    *ngIf="element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0"
                                                                    class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                    style="font-size: 10px;">
                                                                    {{element.ESS_EmpTaxInvestmentDetails_HRAAttachment.length}}
                                                                </span>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-house-fill px-2"></i>Home Loan for Self-Occupied House Property
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_SOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_SOP" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_SOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_SOP">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Annual Interest Paid/Payable</th>
                                                    <th>Principal Repayment Amount</th>
                                                    <th>Lender Name</th>
                                                    <th>Lender PAN No</th>
                                                    <th>Property Address</th>
                                                    <th>Possession Date</th>
                                                    <th>Co-Owned Property (Yes/No)</th>
                                                    <th>Co-Owner Name</th>
                                                    <th>Co-Owner Share (%)</th>
                                                    <th class="sticky-col">Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of DetailData.ESS_EmpTaxDeclarationDetails_SOP; let i = index">
                                                    <td>
                                                        {{element.AnnualInterestPaidORPayable}}
                                                    </td>
                                                    <td>
                                                        {{element.PrincipalRepaymentAmount}}
                                                    </td>
                                                    <td>
                                                        {{element.LenderName}}
                                                    </td>
                                                    <td>
                                                        {{element.LenderPANNo}}
                                                    </td>
                                                    <td>
                                                        {{element.PropertyAddress}}
                                                    </td>
                                                    <td>
                                                        {{element.PossessionDate}}
                                                    </td>
                                                    <td>
                                                        {{element.CoOwnedProperty}}
                                                    </td>
                                                    <td>
                                                        {{element.CoOwnerName}}
                                                    </td>
                                                    <td>
                                                        {{element.CoOwnerSharePerc}}
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="element.ESS_EmpTaxInvestmentDetails_SOPAttachment.length > 0?attachmentPopup(i, 4):null">
                                                            <span
                                                                *ngIf="element.ESS_EmpTaxInvestmentDetails_SOPAttachment.length > 0"
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_SOPAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-cash-stack px-2"></i>Are you receiving rental income from Let out
                                Property?
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_LOP?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_LOP" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_LOP')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_LOP">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th class="text-end">Annual Rent Received</th>
                                                    <th class="text-end">Municipal Taxes</th>
                                                    <th class="text-end">Net AnnualValue</th>
                                                    <th class="text-end">Standard Deduction 30%</th>
                                                    <th>Repaying HomeLoan</th>
                                                    <th class="text-end">Principal Paid OnHomeLoan</th>
                                                    <th class="text-end">Interest Paid OnHomeLoan</th>
                                                    <th>Name Of TheLender</th>
                                                    <th>Lender PanNo</th>
                                                    <th class="text-end">NetIncome/Loss</th>
                                                    <th>Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of DetailData.ESS_EmpTaxDeclarationDetails_LOP; let i = index">
                                                    <td class="text-end">
                                                        {{element.AnnualRentReceived}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.MunicipalTaxesPaid}}
                                                    </td>
                                                    <td class="text-end">
                                                        <span class="custom-control">{{element.NetAnnualValue}}</span>
                                                    </td>
                                                    <td class="text-end">
                                                        <span
                                                            class="custom-control">{{element.StandardDeduction}}</span>
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        {{element.RepayingHomeLoanForThisProperty?'Yes':"No"}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.PrincipalPaidOnHomeLoan}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.InterestPaidOnHomeLoan}}
                                                    </td>
                                                    <td>
                                                        {{element.NameOfTheLender}}
                                                    </td>
                                                    <td>
                                                        {{element.LenderPanNo}}
                                                    </td>
                                                    <td class="text-end">
                                                        {{element.NetIncomeLossFromHouseProperty}}
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0?attachmentPopup(i, 4):null">
                                                            <span
                                                                *ngIf="element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0"
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_LOPAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-building px-2"></i>Other Sources of Income
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_Others?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_Others" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_Others')">
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_Others">
                        <div class="card-body">
                            <div class="card-body p-0 px-2">
                                <div class="row">
                                    <div class="col p-0">
                                        <div class="table-container">
                                            <table class="customeDatatable table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th>SubSection Name</th>
                                                        <th>SubSection Description</th>
                                                        <th>Limit Applicable</th>
                                                        <th class="text-end">MaxLimit Amount</th>
                                                        <th class="text-end">Declared Amount</th>
                                                        <th class="text-end">Approved Amount</th>
                                                        <th>Attachment</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let element of DetailData.ESS_EmpTaxDeclarationDetails_Others; let i = index">
                                                        <td>{{element.SubSectionName}}</td>
                                                        <td>{{element.SubSectionDescription}}</td>
                                                        <td>{{DetailData.Table[0].IsNewRegime?element.IsNewMaxlimitapplicable:element.IsOldMaxlimitapplicable}}
                                                        </td>
                                                        <td class="text-end">
                                                            {{DetailData.Table[0].IsNewRegime?element.NewRegimeMaxAmount:element.OldRegimeMaxAmount}}
                                                        </td>
                                                        <td class="text-end">{{element.ProofSubmissionAmount}}</td>
                                                        <td class="text-end">{{element.ApprovedAmount}}</td>
                                                        <td style="align-content: center;text-align: -webkit-center;">
                                                            <i type="button"
                                                                class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                                (click)="element.ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0?attachmentPopup(i, 5):null">
                                                                <span
                                                                    *ngIf="element.ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0"
                                                                    class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                    style="font-size: 10px;">
                                                                    {{element.ESS_EmpTaxInvestmentDetails_OthersAttachment.length}}
                                                                </span>
                                                            </i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="card my-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <span class="custome-header">
                                <i class="bi bi-wallet px-2"></i>TDS/TCS Paid During the Year
                            </span>
                        </div>
                        <div class="col-auto mx-2 align-self-center" style="display: inline-flex;">
                            <span class="px-1"
                                style="font-size: 0.9rem;">{{this.OpenCard.CardEmpTaxDeclarationDetails_TDS?'Yes':'No'}}</span>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch"
                                    [checked]="OpenCard.CardEmpTaxDeclarationDetails_TDS" id="flexSwitchCheckChecked"
                                    (change)="onSwitchChange($event,'CardEmpTaxDeclarationDetails_TDS')">
                            </div>
                        </div>
                    </div>
                </div>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="!OpenCard.CardEmpTaxDeclarationDetails_TDS">
                    <div class="card-body">
                        <div class="card-body p-0 px-2">
                            <div class="row">
                                <div class="col p-0">
                                    <div class="table-container">
                                        <table class="customeDatatable table table-bordered">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>TDS/TCS Paid</th>
                                                    <th>Challan No</th>
                                                    <th>Payment Date</th>
                                                    <th class="sticky-col">Attachment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let element of DetailData.ESS_EmpTaxDeclarationDetails_TDS; let i = index">
                                                    <td>
                                                        {{element.TDSorTCSPaid}}
                                                    </td>
                                                    <td>
                                                        {{element.ChallanNo}}
                                                    </td>
                                                    <td>
                                                        {{element.PaymentDate}}
                                                    </td>
                                                    <td style="align-content: center;text-align: -webkit-center;">
                                                        <i type="button"
                                                            class="bi bi-file-earmark-arrow-down cursor-pointer position-relative fs-5"
                                                            (click)="element.ESS_EmpTaxInvestmentDetails_TDSAttachment.length > 0?attachmentPopup(i, 4):null">
                                                            <span
                                                                *ngIf="element.ESS_EmpTaxInvestmentDetails_TDSAttachment.length > 0"
                                                                class="position-absolute top-0 start-1 translate-middle badge rounded-pill bg-primary"
                                                                style="font-size: 10px;">
                                                                {{element.ESS_EmpTaxInvestmentDetails_TDSAttachment.length}}
                                                            </span>
                                                        </i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button *ngIf="(!this.Filter.IsDraft && this.user.UserType == 'A')" type="button"
                    class="btn btn-outline-danger mx-1" [disabled]="isDisabled" (click)="Delete()"><i
                        class="bi bi-trash" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Delete':'Loading...'}}</button>

                <button type="button" class="btn btn-outline-primary me-1" [disabled]="isDisabled" (click)="Cancel()"><i
                        class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled" (click)="GenerateTDSReport()"
                    *ngIf="!this.Filter.IsDraft && common.ToLowerCase(DetailData.Table[0].ApprovalStatus) == 'approved'"><i
                        class="bi bi-file-earmark-arrow-down-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'TDS Report':'Loading...'}}</button>

                <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                    [routerLink]="['/request/incometax/taxinvestment/add/' + this.Filter.WebESSApprovalRequestTrackingId]"
                    *ngIf="(this.Filter.IsDraft) && this.common.PageRight.IsEdit"><i class="bi bi-chevron-right"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Edit':'Loading...'}}</button>

                <button type="button" class="btn btn-primary mx-1" [disabled]="isDisabled"
                    [routerLink]="['/incometax/incometax/add/e/r/' + this.Filter.WebESSApprovalRequestTrackingId]"
                    *ngIf="!this.Filter.IsDraft && this.user.UserType == 'A' && this.common.PageRight.IsEdit"><i
                        class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Edit':'Loading...'}}</button>

                <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                    [routerLink]="['/incometax/compare/i/' + this.Filter.WebESSApprovalRequestTrackingId]"><i
                        class="bi bi-bookmark-check" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Compare':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>